<template>
  <div class="rate" id="rate">
    <!-- COMPONENTE DE BARRA DE PROGRESSO -->
    <PmwTopProgress :start="loading" :done="!loading" color="#53B483" />

    <SidebarLayout3
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
      class="hotel--sidebar"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- PAINEL AZUL -->
        <div class="page-actions">
          <transition name="fade">
            <SidebarPanel
              :fluctuationData="apiObjectData"
              :hotelData="hotelData"
            />
          </transition>

          <!-- BOTÃO DE HISTORICO -->
          <div v-if="false" class="sidebar--history">
            Ver histórico
          </div>
        </div>

        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <PmwHeading
            class="sidebar--title"
            size="paragraph-80"
            weight="weight-medium"
          >
            Ações da página
          </PmwHeading>

          <!-- SALVAR -->
          <PmwButton
            :disabled="loading || !isCoeficienteDiasSemanaValid"
            variation="pmw-primary"
            class="sidebar--button"
            @click="saveFluctuation(rateId)"
          >
            Salvar
          </PmwButton>

          <!-- VOLTAR -->
          <PmwButton
            v-if="false"
            :hasIcon="true"
            layout="outline"
            variation="blue-100"
            class="sidebar--button button__outline"
          >
            <template #icon>
              <img :src="eyeIcon" />
            </template>
            <template>
              <div class="sidebar--button-text">Pré-Visualizar</div>
            </template>
          </PmwButton>

          <!-- INATIVAR -->
          <PmwButton
            v-if="$route.params.rateId && apiObjectData.ativo"
            :disabled="loading"
            variation="red-100"
            class="sidebar--button"
            @click="showDeleteModal = true"
          >
            Inativar
          </PmwButton>

          <!-- ATIVAR -->
          <PmwButton
            v-if="$route.params.rateId && !apiObjectData.ativo"
            :disabled="loading"
            variation="blue-100"
            class="sidebar--button"
            @click="showActivateModal = true"
          >
            Ativar
          </PmwButton>

          <PmwButton
            :link="`/hoteis/regras-tarifarias/${$route.params.id}`"
            :disabled="loading"
            layout="outline"
            variation="blue-100"
            element="router-link"
            class="sidebar--button"
          >
            Voltar sem salvar
          </PmwButton>
        </SidebarBlock>
      </template>

      <template #content>
        <!-- NOME E ENDEREÇO DO HOTEL -->
        <PmwAccordion class="pmw-accordion">
          <PmwAccordionItem
            :startOpen="false"
            :required="true"
            :defaultTitle="false"
            :validatedItens="basicValidatedItens"
            requiredInfoTooltipText="Possui campos obrigatórios."
            title="Ativação básica"
            description="Configurações da tarifa, do PMS e de desconto"
            ref="accordion-1"
            class="pmw-accordion--item"
            @open="loadAssociationOptions"
            @close="basicItensValidation"
          >
            <template v-slot:content>
              <!-- ACCORDION 1 -->
              <BasicActivation
                :fluctuationData="apiObjectData"
                :hotelRoomsData="hotelRoomsData"
                :reloadAbsolute="reloadAbsolute"
                :baseRateOptions="baseRateOptions"
                :hotelPms="hotelData?.pms"
                :errors="errors"
                @load-hotel-rooms-data="getHotelRoomsData"
              />

              <!-- ASSOCIAR REGRA A UM DESCONTO EXISTENTE (apenas criação) -->
              <div
                v-if="
                  !$route.params.rateId &&
                    (!bothOptionsLoaded ||
                      couponOptions.length ||
                      exclusiveDiscountOptions.length)
                "
                class="associate-discount"
              >
                <div class="form--title">
                  <PmwHeading size="paragraph-80" weight="weight-light">
                    Associar regra a um desconto existente
                  </PmwHeading>
                </div>

                <div class="associate-discount--columns">
                  <div
                    v-if="!couponOptionsLoaded || couponOptions.length"
                    class="associate-discount--column"
                  >
                    <PmwInputCheckbox
                      v-model="associateCoupon"
                      :checked="associateCoupon"
                      label="Associar a um cupom de desconto"
                      @input="handleCouponCheckbox"
                    />
                    <div
                      v-if="associateCoupon"
                      class="associate-discount--select-item"
                    >
                      <FormSelectCoupon
                        v-if="couponOptionsLoaded"
                        v-model="selectedCoupons"
                        :options="couponOptions"
                        label="Cupom de desconto"
                        placeholder="Selecione"
                        searchPlaceholder="Buscar cupom"
                        name="cupons"
                        search
                        multiple
                        toggleAll
                      />
                    </div>
                  </div>

                  <div
                    v-if="
                      !exclusiveDiscountOptionsLoaded ||
                        exclusiveDiscountOptions.length
                    "
                    class="associate-discount--column"
                  >
                    <PmwInputCheckbox
                      v-model="associateExclusiveDiscount"
                      :checked="associateExclusiveDiscount"
                      label="Associar a um Desconto exclusivo"
                      @input="handleExclusiveDiscountCheckbox"
                    />
                    <div
                      v-if="associateExclusiveDiscount"
                      class="associate-discount--select-item"
                    >
                      <FormSelectCoupon
                        v-if="exclusiveDiscountOptionsLoaded"
                        v-model="selectedExclusiveDiscounts"
                        :options="exclusiveDiscountOptions"
                        label="Desconto exclusivo"
                        placeholder="Selecione"
                        searchPlaceholder="Buscar desconto"
                        name="descontosExclusivos"
                        search
                        multiple
                        toggleAll
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- INFORMAÇÕES DE CONTATO -->
        <div class="reference-tour" id="form--contact">
          <PmwAccordion class="pmw-accordion">
            <PmwAccordionItem
              :defaultTitle="false"
              :validatedItens="pricingValidatedItens"
              title="Configuração da precificação"
              description="Defina os diferenciais de acomodações e os valores de pensões."
              ref="accordion-2"
              class="pmw-accordion--item pmw-accordion--item__min-spacing"
              @open="openPricing"
              @close="pricingItensValidation"
            >
              <template v-slot:content>
                <!-- ACCORDION 2 -->
                <PensionByAgeVue
                  :fluctuationData="apiObjectData"
                  :errors="errors"
                  :paxData="hotelData?.paxCriancas"
                  @load-hotel-data="getHotelData"
                />

                <SeparateLine :top="20" :right="-10" :bottom="35" :left="-10" />

                <FreeNight :fluctuationData="apiObjectData" :errors="errors" />

                <SeparateLine :top="20" :right="-10" :bottom="35" :left="-10" />

                <AccomodationsValues
                  v-if="showDifferentials"
                  :isOpen="accomodationIsOpen"
                  :fluctuationData="apiObjectData"
                  :hotelRoomsData="hotelRoomsData"
                  :errors="errors"
                  @close="accomodationIsOpen = false"
                  @load-hotel-rooms-data="getHotelRoomsData"
                />

                <SeparateLine
                  v-if="showDifferentials"
                  :top="20"
                  :right="-10"
                  :bottom="35"
                  :left="-10"
                />

                <AdditionalPax
                  v-if="showDifferentials"
                  :isOpen="additionalPaxIsOpen"
                  :fluctuationData="apiObjectData"
                  :hotelRoomsData="hotelRoomsData"
                  :errors="errors"
                  @close="additionalPaxIsOpen = false"
                  @load-hotel-rooms-data="getHotelRoomsData"
                />

                <SeparateLine
                  v-if="showDifferentials"
                  :top="20"
                  :right="-10"
                  :bottom="35"
                  :left="-10"
                />
              </template>
            </PmwAccordionItem>
          </PmwAccordion>
        </div>

        <!-- HORÁRIOS DE CHECKIN/CHECKOUT E CONFIGURAÇÃO DE PAGAMENTO -->
        <PmwAccordion class="pmw-accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            :validatedItens="periodsValidatedItens"
            title="Configuração de períodos"
            requiredInfoTooltipText="Possui campos obrigatórios."
            description="Defina o período da reserva, da hospedagem, dias de Blackout e Check-in e Check-out Flexíveis."
            ref="accordion-3"
            class="pmw-accordion--item"
            @open="loadPeriodsComponent = true"
            @close="periodsItensValidation"
          >
            <template v-slot:content>
              <!-- ACCORDION 3 -->
              <PeriodConfiguration
                v-if="loadPeriodsComponent"
                :fluctuationData="apiObjectData"
                :errors="errors"
              />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- MODALIDADE DE COBRANÇA E POLÍTICA DE REEMBOLSO -->
        <div class="reference-tour" id="form--payments">
          <PmwAccordion class="pmw-accordion">
            <PmwAccordionItem
              :defaultTitle="false"
              :validatedItens="restrictionsValidatedItens"
              title="Configurações e restrições da tarifa"
              description="Defina os regramentos para que essa tarifa apareça disponível para venda se houver."
              ref="accordion-4"
              class="pmw-accordion--item"
              @open="openRestrictionHandler"
              @close="restrictionsItensValidation"
            >
              <template v-slot:content>
                <!-- ACCORDION 4 -->
                <RestrictionsSettings
                  v-if="loadRestrictionComponent"
                  :fluctuationData="apiObjectData"
                  :hotelRoomsData="hotelRoomsData"
                  :crmGroupsData="crmGroupsData"
                  :errors="errors"
                  @showInputs="showInputsHandler"
                />
              </template>
            </PmwAccordionItem>
          </PmwAccordion>
        </div>

        <!-- DESCRIÇÃO E AMENIDADES DO HOTEL -->
        <PmwAccordion class="pmw-accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            :validatedItens="policiesValidatedItens"
            title="Politica da tarifa"
            description="Defina as regras da tarifa, formas de pagamento que são aceitas e demais diferenciais."
            ref="accordion-5"
            class="pmw-accordion--item"
            @open="openPoliciesHandler"
            @close="policiesItensValidation"
          >
            <template v-slot:content>
              <!-- ACCORDION 5 -->
              <RatePolicy
                v-if="loadPoliciesComponent"
                :fluctuationData="apiObjectData"
                :rateItensOptions="rateIncludedItens"
                :hotelPaymentForms="hotelPaymentForms"
                :hotelData="hotelData"
                @load-payment-forms="loadPaymentForms"
              />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- AÇÕES -->
        <div class="form--actions">
          <!-- CANCELAR -->
          <PmwButton
            :link="`/hoteis/regras-tarifarias/${$route.params.id}`"
            :disabled="loading"
            layout="outline"
            variation="blue-100"
            element="router-link"
            size="large"
            class="sidebar--button button__outline"
          >
            Voltar sem salvar
          </PmwButton>
          <!-- SALVAR -->
          <PmwButton
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            :popperStrategy="'auto'"
            :disabled="loading || !isCoeficienteDiasSemanaValid"
            size="large"
            variation="pmw-primary"
            @click="saveFluctuation(rateId)"
          >
            Salvar
          </PmwButton>
        </div>
      </template>
    </SidebarLayout3>

    <!-- MODAL DE HISTORICO -->
    <HistoryModal :showModal="false" />

    <!-- MODAL DE ALERTA PARA INFORMAR QUE NENHUM GRUPO CRM ATIVO ESTÁ VINCULADO À TARIFA -->
    <PmwAlertModal
      v-model="showAlertInactiveGroups"
      title="Nenhum grupo selecionado anteriormente nesta regra está ativo."
      text="Ao prosseguir, se outro grupo não for selecionado, essa tarifa se tornará publica, podendo ser vendida para qualquer pessoa que entrar no motor de reservas"
      iconColor="red-100"
      icon="pmw-x-icon"
      cancelButtonText="Cancelar"
      confirmButtonText="Prosseguir"
      closeButton
      @alert-modal-confirm="showAlertInactiveGroups = false"
      @alert-modal-cancel="goBackRatesList()"
    >
    </PmwAlertModal>

    <!-- MODAL DE CONFIRMAÇÃO ANTES DE SALVAR -->
    <ModalPreviewSaveData
      v-model="showPreviewSaveData"
      title="Pronto para salvar?"
      description="Confira os dados da sua flutuação abaixo"
    />

    <DeleteRateModel
      :showDeleteModal="showDeleteModal"
      @close="showDeleteModal = false"
      @disable="disableRates"
    />

    <ActivateRateModel
      :showActivateModal="showActivateModal"
      @close="showActivateModal = false"
      @activate="saveFluctuation(rateId, true)"
    />
  </div>
</template>

<script>
/**
 * TODO Carregar os módulos assíncronamente. (Nice to Have)
 */
import { mapActions, mapGetters } from 'vuex'
// import { differenceInDays } from 'date-fns'
import eyeIcon from '@/assets/icons/eye.svg'
import { dateToISO } from '@/helpers/date'

import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwAccordion from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion'
import PmwAccordionItem from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion/PmwAccordionItem'
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwInputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/PmwInputCheckbox'
import FormSelectCoupon from '@/components/_base/elements/FormSelectCoupon/FormSelectCoupon.vue'

/** Segmentação do formulário de cadastro */
import BasicActivation from '@/components/hotel/rateFluctuations/basicActivation/BasicActivation'
import PensionByAgeVue from '@/components/hotel/rateFluctuations/pricingConfiguration/PensionByAge'
import FreeNight from '@/components/hotel/rateFluctuations/pricingConfiguration/FreeNight'
import AdditionalPax from '@/components/hotel/rateFluctuations/pricingConfiguration/AdditionalPax'
import AccomodationsValues from '@/components/hotel/rateFluctuations/pricingConfiguration/AccomodationsValues'
import HistoryModal from '@/components/hotel/rateFluctuations/rateModals/HistoryModal'
import SidebarPanel from '@/components/hotel/rateFluctuations/SidebarPanel'

import hotelFluctuationValidation from '@/mixins/hotelFluctuationValidation'

const PeriodConfiguration = () =>
  import(
    '@/components/hotel/rateFluctuations/periodConfiguration/PeriodConfiguration'
  )

const RestrictionsSettings = () =>
  import(
    '@/components/hotel/rateFluctuations/restrictionsSettings/RestrictionsSettings'
  )

const RatePolicy = () =>
  import('@/components/hotel/rateFluctuations/ratePolicy/RatePolicy')

const ModalPreviewSaveData = () =>
  import('../../../components/hotel/rateFluctuations/modalPreviewSaveData')

const DeleteRateModel = () =>
  import('../../../components/hotel/rateFluctuations/DeleteRateModel')

const ActivateRateModel = () =>
  import('../../../components/hotel/rateFluctuations/ActivateRateModel')

import { defaultObjStructure } from '@/helpers/hotelFluctuations'

export default {
  name: 'RateFluctuationsCreate',
  mixins: [hotelFluctuationValidation],
  components: {
    SidebarLayout3,
    SidebarBlock,
    PmwHeading,
    PmwButton,
    PmwAccordion,
    PmwAccordionItem,
    BasicActivation,
    RatePolicy,
    PmwTopProgress,
    SidebarPanel,
    PensionByAgeVue,
    FreeNight,
    PeriodConfiguration,
    RestrictionsSettings,
    SeparateLine,
    HistoryModal,
    ModalPreviewSaveData,
    DeleteRateModel,
    ActivateRateModel,
    AccomodationsValues,
    AdditionalPax,
    PmwAlertModal,
    PmwInputCheckbox,
    FormSelectCoupon
  },

  data() {
    return {
      showInputs: null,

      eyeIcon: eyeIcon,

      /** Caminhos da página */
      rootPath: {
        /** ponto de partida do breadcrumb  */
        label: 'Home',
        url: '/reservas',
        isSpa: true /** se deve ser um link para o site novo ou antigo */
      },

      pageTitle: 'Criar regra',

      showDeleteModal: false,

      showActivateModal: false,

      /** Caminho de pão */
      breadcrumb: [
        {
          label: 'Letsbook',
          url: '',
          isSpa: false
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true
        },
        {
          label: 'Regras tarifárias',
          url: `/hoteis/regras-tarifarias/${this.$route.params.id}`,
          isSpa: true
        },
        {
          label: 'Criar regra',
          url: '',
          isSpa: false
        }
      ],

      /** Se os métodos de criar e salvar estão sendo processados */
      loading: false,

      /** Apresenta a modal de preview */
      showPreviewSaveData: false,

      /** Apresenta a modal de alerta de grupos inativos na tarifa */
      showAlertInactiveGroups: false,

      /** Objeto padrão da api para criar uma flutuação */
      apiObjectData: defaultObjStructure(),

      /** Dados de config do hotel */
      hotelData: null,

      /** Dados de quartos do hotel */
      hotelRoomsData: [],

      accomodationIsOpen: false,

      additionalPaxIsOpen: false,

      /** Dados de grupos crm do hotel */
      crmGroupsData: [],

      /** Itens inclusos na tarifa */
      rateIncludedItens: [],

      /** Se deve carregar o component de politicas */
      loadPoliciesComponent: false,

      /** Se deve carregar o component de restrições */
      loadRestrictionComponent: false,

      /** Se deve carregar o component de períodos */
      loadPeriodsComponent: false,

      /** Formas de pagamento do hotel */
      hotelPaymentForms: [],

      /** Id da flutuação em caso de edição */
      rateId: null,

      /** Listagem de erros retornados pelo endpoint */
      errors: [],

      reloadAbsolute: false,

      /** Opçoes de tarifa base */
      baseRateOptions: [],

      /** Associação de cupons */
      associateCoupon: false,
      selectedCoupons: [],
      couponOptions: [],

      /** Associação de descontos exclusivos */
      associateExclusiveDiscount: false,
      selectedExclusiveDiscounts: [],
      exclusiveDiscountOptions: [],

      /** Flags que indicam que as opções já foram carregadas da API */
      couponOptionsLoaded: false,
      exclusiveDiscountOptionsLoaded: false,

      /** Elementos dentro dos accordions */
      elements: [
        {
          accordion: 'accordion-1',
          errors: [
            'Nome',
            'CodigoTarifaBase',
            'Coeficiente',
            'CoeficienteDiasSemana',
            'PrecosQuartos'
          ]
        },
        {
          accordion: 'accordion-2',
          errors: [
            'Pensoes.LimiteUso',
            'DiariasNoitesGratis',
            'QuantidadeNoitesGratis'
          ]
        },
        {
          accordion: 'accordion-3',
          errors: ['CoeficienteCheckin', 'CoeficienteCheckout']
        },
        {
          accordion: 'accordion-4',
          errors: ['UrlImagemPromocional', 'MaximoAdultos', 'MinimoAdultos']
        }
      ]
    }
  },

  computed: {
    ...mapGetters('hotel', ['getTarifarioAbsoluto']),
    ...mapGetters('user', ['getPermissions']),

    showDifferentials() {
      if (
        !this.hotelData?.tarifarioAbsoluto &&
        this.apiObjectData?.tipoCoeficiente === 0
      ) {
        return true
      }

      return false
    },

    isCoeficienteDiasSemanaValid() {
      if (this.apiObjectData.coeficienteDiasSemana?.length) {
        /* Verifica se todos os coeficientes estão preenchidos */
        return this.apiObjectData.coeficienteDiasSemana.every(
          (item) => item.coeficiente
        )
      }

      return true
    },

    bothOptionsLoaded() {
      return this.couponOptionsLoaded && this.exclusiveDiscountOptionsLoaded
    }
  },

  async created() {
    this.rateId = +this.$route.params.rateId || null

    if (this.rateId) {
      this.loadPaymentForms()
      await this.getRateData()
      await this.getAbsoluteRates()
      await this.getHotelData()
      await this.getValidations()
    } else {
      this.getHotelData()
      this.loadPaymentForms()
      await this.getAbsoluteRates()
      await this.getHotelRoomsData()
    }

    await this.getCrmGroups()
  },

  methods: {
    ...mapActions('hotel', ['setTarifarioAbsoluto']),

    showInputsHandler(newVal) {
      this.showInputs = newVal
    },

    async getRateData() {
      this.loading = true
      await this.$rate
        .getRuleRate(this.rateId)
        .then((response) => {
          this.apiObjectData = response.data

          this.forceBoardInitialValue()

          /** Ajuste de breadcrumb */
          this.breadcrumb[3].label = `Editando ${this.apiObjectData.nome}`

          /** Ajuste de titulo da página */
          this.pageTitle = `Editando ${this.apiObjectData.nome}`
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Força o valor 2 para quando o limite de uso de uma pensão for nulo */
    forceBoardInitialValue() {
      if (this.apiObjectData.pensoes?.length) {
        this.apiObjectData.pensoes.forEach((item) => {
          item.limiteUso = item.limiteUso ?? 2
        })
      }
    },

    getAbsoluteRates() {
      this.$rate.getAbsoluteRates(this.$route.params.id).then((response) => {
        this.baseRateOptions = response.data.map((item) => {
          return { text: item.nome ?? 'Sem nome', value: item.codigo }
        })
      })
    },

    validateBoardFields(boardArray) {
      return boardArray?.filter((item) => {
        return (
          (item.valorCafe !== null && item.valorCafe !== '') ||
          (item.valorAlmoco !== null && item.valorAlmoco !== '') ||
          (item.valorJanta !== null && item.valorJanta !== '') ||
          (item.valorTotal !== null && item.valorTotal !== '')
        )
      })
    },

    validateRoomPrice(roomsPrices) {
      const filteredRoomsPrices = roomsPrices.filter((room) => {
        const hasNonNullValue = room.valoresOcupantes.some(
          (valoresOcupante) =>
            valoresOcupante.valor !== null && valoresOcupante.valor !== ''
        )

        /* Retorna true para manter o objeto, false para removê-lo */
        return hasNonNullValue
      })

      return filteredRoomsPrices
    },

    async getValidations() {
      this.basicItensValidation()
      this.pricingItensValidation()
      this.periodsItensValidation()
      await this.restrictionsItensValidation()
      await this.policiesItensValidation()
    },

    validateFlexibleCheckInOut() {
      let isValid = true
      const errorMessages = []

      if (this.apiObjectData.diasToleranciaCheckin) {
        if (!this.apiObjectData.coeficienteCheckin) {
          isValid = false
          this.openAccordion('accordion-3')
          this.errors.push('CoeficienteCheckin')
          errorMessages.push('Coeficiente checkin flexível deve ser preenchido')
        }
      }

      if (this.apiObjectData.diasToleranciaCheckout) {
        if (!this.apiObjectData.coeficienteCheckout) {
          isValid = false
          this.openAccordion('accordion-3')
          this.errors.push('CoeficienteCheckout')
          errorMessages.push(
            'Coeficiente checkout flexível deve ser preenchido'
          )
        }
      }

      if (!isValid) {
        this.$bus.$emit('show-alert-chip', {
          message: errorMessages
        })
      }

      return isValid
    },

    /** Salva a regra tarifária
     * @param rateId - Id da tarifa
     * @param isReactivation - Se é ativação/reativação
     */
    async saveFluctuation(rateId, isReactivation) {
      let method = 'createRuleRate'

      /** Aciona o loading */
      this.loading = true

      /** Limpa os erros */
      this.clearErrors()

      if (this.apiObjectData.maximoAdultos <= 0 && this.showInputs) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de adultos deve ser pelo menos 1.'
        })

        this.openAccordion('accordion-4')
        this.errors.push('MaximoAdultos')
        this.loading = false
        return
      }

      if (this.apiObjectData.minimoAdultos <= 0 && this.showInputs) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de adultos deve ser pelo menos 1.'
        })

        this.openAccordion('accordion-4')
        this.errors.push('MinimoAdultos')
        this.loading = false
        return
      }

      if (this.apiObjectData.minimoAdultos > this.apiObjectData.maximoAdultos) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de adultos deve ser maior que o mínimo.'
        })

        this.openAccordion('accordion-4')
        this.errors.push('MaximoAdultos')
        this.loading = false
        return
      }

      const isFilledAndInvalid = (val) =>
        val !== null && val !== undefined && val !== '' && val <= 0

      if (isFilledAndInvalid(this.apiObjectData.minimoNoitesDe)) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O valor para "Mínimo de Noites" deve ser maior que 0.'
        })
        this.openAccordion('accordion-3')
        this.errors.push('minimoNoitesDe')
        this.loading = false
        return
      }

      if (isFilledAndInvalid(this.apiObjectData.minimoNoitesAte)) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O valor para "Máximo de Noites" deve ser maior que 0.'
        })
        this.openAccordion('accordion-3')
        this.errors.push('minimoNoitesAte')
        this.loading = false
        return
      }

      if (
        this.apiObjectData.minimoCriancas > this.apiObjectData.maximoCriancas
      ) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de crianças deve ser maior que o mínimo.'
        })

        this.openAccordion('accordion-4')
        this.errors.push('MaximoCriancas')
        this.loading = false
        return
      }

      if (this.apiObjectData.precosQuartos?.length) {
        this.apiObjectData.precosQuartos = this.validateRoomPrice(
          this.apiObjectData.precosQuartos
        )

        if (
          this.apiObjectData.precosQuartos.some((room) => {
            return room.valoresOcupantes.some(
              (item) => item.valor === null || item.valor === ''
            )
          })
        ) {
          this.$bus.$emit('show-alert-chip', {
            message: 'Para salvar, preencha todos os valores do quarto editado'
          })

          this.reloadAbsolute = !this.reloadAbsolute
          this.loading = false
          return
        }
      }

      if (
        this.apiObjectData.promocao &&
        !this.apiObjectData.urlImagemPromocional
      ) {
        this.$bus.$emit('show-alert-chip', {
          message:
            'Para ativar tarifa como promocional, faça upload de uma foto da promoção'
        })

        this.openAccordion('accordion-4')
        this.errors.push('UrlImagemPromocional')
        this.loading = false
        return
      }

      if (
        this.getTarifarioAbsoluto &&
        this.baseRateOptions?.length > 1 &&
        this.apiObjectData.tipoCoeficiente === 0
      ) {
        if (!this.apiObjectData.codigoTarifaBase) {
          this.$bus.$emit('show-alert-chip', {
            message: 'Para salvar, selecione uma tarifa base'
          })

          this.openAccordion('accordion-1')
          this.errors.push('CodigoTarifaBase')
          this.loading = false
          return
        }
      }

      let originalAllotment = []

      if (this.apiObjectData.diferenciaisQuartos?.length) {
        this.apiObjectData.diferenciaisQuartos = this.apiObjectData.diferenciaisQuartos.filter(
          (quarto) => Object.values(quarto).every((value) => value !== null)
        )
      }

      if (this.apiObjectData.diferenciaisPax?.length) {
        this.apiObjectData.diferenciaisPax = this.apiObjectData.diferenciaisPax.filter(
          (item) => item.valorAdicional !== null && item.valorAdicional !== ''
        )
      }

      if (this.apiObjectData.allotmentQuartos?.length) {
        originalAllotment = [...this.apiObjectData.allotmentQuartos]

        this.apiObjectData.allotmentQuartos = this.apiObjectData.allotmentQuartos.filter(
          (quarto) => quarto.allotment !== null && quarto.allotment !== ''
        )
      }

      const idiomaPt = this.apiObjectData.idiomas?.filter(
        (item) => item.idioma === 'pt-BR'
      )

      if (
        (!this.apiObjectData.nome || this.apiObjectData.nome === '') &&
        (idiomaPt[0].nome || idiomaPt[0].nome !== '')
      ) {
        this.apiObjectData.nome = idiomaPt[0].nome
      }

      if (rateId) {
        this.apiObjectData.codigo = rateId
        method = 'editRuleRate'
      }

      if (isReactivation) {
        this.apiObjectData.ativo = true
      }

      if (!this.validateFlexibleCheckInOut()) {
        this.loading = false
        return
      }

      /** Formata datas de blackout */
      if (this.apiObjectData.periodosBlackout?.length) {
        /** Formata as datas para o padrão ISO */
        this.apiObjectData.periodosBlackout.map((dateObj) => {
          if (dateObj.dataInicio instanceof Date) {
            dateObj.dataInicio = dateToISO(dateObj.dataInicio, true)
          }

          if (dateObj.dataFim instanceof Date) {
            dateObj.dataFim = dateToISO(dateObj.dataFim, true)
          }

          return dateObj
        })
      }

      /** Formata as datas do periodo de hospedagem */
      if (this.apiObjectData.periodosHospedagem?.length) {
        if (this.apiObjectData.diasToleranciaCheckin === 0) {
          this.$bus.$emit('show-alert-chip', {
            message:
              'A quantidade de dias de Check-in Flexível deve ser maior que 0'
          })
          this.openAccordion('accordion-3')

          this.loading = false
          return
        }

        if (this.apiObjectData.diasToleranciaCheckout === 0) {
          this.$bus.$emit('show-alert-chip', {
            message:
              'A quantidade de dias de Check-out Flexível deve ser maior que 0'
          })
          this.openAccordion('accordion-3')
          this.loading = false
          return
        }

        /** Formata as datas para o padrão ISO */
        this.apiObjectData.periodosHospedagem.map((dateObj) => {
          if (dateObj.dataInicio instanceof Date) {
            dateObj.dataInicio = dateToISO(dateObj.dataInicio, true)
          }

          if (dateObj.dataFim instanceof Date) {
            dateObj.dataFim = dateToISO(dateObj.dataFim, true)
          }

          return dateObj
        })
      }

      this.apiObjectData.pensoes = await this.validateBoardFields(
        this.apiObjectData.pensoes
      )

      /** Evita pré-pagamento com gateway diferente do mundipagg */
      if (
        this.hotelData.gatewayPagamento !== 'MUNDIPAGG' &&
        !this.hotelData?.habilitarPagamentoPix &&
        this.apiObjectData.meiosPagamento?.some(
          (item) => item.tipoPagamento === 2
        )
      ) {
        this.$bus.$emit('show-alert-chip', {
          message:
            'O hotel não tem gateway de pagamento e por isso não pode ter uma flutuação pré-paga.'
        })

        this.loading = false

        this.openAccordion('accordion-5')
        return
      }

      /** Adiciona os IDs de cupons e descontos exclusivos ao payload (apenas criação) */
      if (!rateId) {
        if (this.selectedCoupons.length) {
          this.apiObjectData.cupomIds = this.selectedCoupons.map(
            (item) => item.codigo
          )
        }
        if (this.selectedExclusiveDiscounts.length) {
          this.apiObjectData.descontoExclusivoIds = this.selectedExclusiveDiscounts.map(
            (item) => item.codigo
          )
        }
      }

      this.$rate[method](this.apiObjectData)
        .then(() => {
          /** Feedback de sucesso */
          if (isReactivation) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Regra tarifária ativada com sucesso!'
            })
          } else {
            this.$bus.$emit('show-alert-chip', {
              message: 'Regra tarifária salva com sucesso!'
            })
          }

          /** Redirecionar para a tela de listagem de regra tarifarias */
          setTimeout(() => {
            this.$router.push({
              path: `/hoteis/regras-tarifarias/${this.$route.params.id}`
            })
          }, 500)
        })
        .catch((error) => {
          if (originalAllotment) {
            this.apiObjectData.allotmentQuartos = originalAllotment
          }
          if (error.messages[0].startsWith('Ocorreu')) {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages[0]
            })
          } else {
            this.showErrors(error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Detectar se houve erro
     * @param {Object} error: Objeto de erro retornado no endpoint
     */
    showErrors(error) {
      let apiErrorMessages = []

      /** Verifica se há uma listagem dos erros */
      if (Array.isArray(error?.response?.data)) {
        /** Identifica os campos com erro */
        this.errors = error.response.data.map((err) => err.property)
        apiErrorMessages = error.response.data.map((err) => err.message)
      } else if (error?.response?.data?.errors) {
        this.errors = Object.keys(error?.response?.data?.errors)
      }
      /** Se houver campo com erro */
      if (this.errors.length) {
        /** Pegar primeiro campo do erro */
        const firstError = this.errors[0]

        /** Pegar o accordion pelo erro */
        const accordion = this.elements.find((element) =>
          element.errors.includes(firstError)
        )?.accordion
        /** Abrir accordion */
        if (accordion) this.openAccordion(accordion)
        /** Pegar o elemento pelo 'data-error' (form input ou select) */
        const element = document.querySelector(`[data-error="${firstError}"]`)
        if (element) {
          setTimeout(() => {
            /** Scrollar até o elemento */
            document
              .querySelector(`[data-error="${firstError}"]`)
              .scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
          }, 500)
        }
      }

      /** Ajustar os alertas */
      const messages = error.messages.map((message) => {
        if (message.includes('must not be empty')) {
          return message.replace('must not be empty', 'não pode estar vazio(a)')
        } else if (message.includes('must be greater than')) {
          return message.replace('must be greater than', 'deve ser maior que')
        }
      })

      messages.push(...apiErrorMessages.map((item) => item))

      this.$bus.$emit('show-alert-chip', {
        message: messages
      })
    },

    /** Limpar erros */
    clearErrors() {
      this.errors = []
    },

    /** Abrir accordion específico
     * @param {String} id: Id específico do accordion
     */
    openAccordion(id) {
      !this.$refs[id].show ? this.$refs[id].open() : false
    },

    getHotelData() {
      if (!this.hotelData) {
        this.$hotel.get(this.$route.params.id).then((response) => {
          this.hotelData = response.data

          this.apiObjectData.habilitarPagamentoPix =
            this.hotelData?.pixHabilitadoTodasTarifas ||
            this.apiObjectData.habilitarPagamentoPix

          this.setTarifarioAbsoluto(this.hotelData.tarifarioAbsoluto)

          this.breadcrumb.splice(2, 0, {
            label: this.hotelData.nome,
            url: `/hoteis/editar/${this.$route.params.id}`,
            isSpa: true
          })
        })
      }
    },

    async getHotelRoomsData() {
      if (!this.hotelRoomsData.length) {
        await this.$room.get(this.$route.params.id, true).then((response) => {
          this.hotelRoomsData = response.data

          if (
            this.apiObjectData.tipoCoeficiente === 0 &&
            (!this.apiObjectData.quartos || !this.apiObjectData.quartos.length)
          ) {
            this.apiObjectData.quartos = []

            this.hotelRoomsData.forEach((room) => {
              this.apiObjectData.quartos.push(room.codigo)
            })
          }
        })
      }
    },

    getCrmGroups() {
      this.$hotel.getCrmGroups(this.$route.params.id).then((response) => {
        this.crmGroupsData = response.data

        /** Verificar se os grupos registrados na tarifa estão ativos */
        if (this.rateId) {
          if (this.apiObjectData?.gruposCrm) {
            this.showAlertInactiveGroups = !this.verifyCrmGroups(
              this.crmGroupsData,
              this.apiObjectData?.gruposCrm
            )

            /** Limpar campo dos grupos caso não haja nenhum grupo crm ativo */
            if (this.showAlertInactiveGroups) {
              this.apiObjectData.gruposCrm = []
            }
          }
        }
      })
    },

    /**
     * Verificar se ao menos um grupos da tarifa esteja ativo
     * @param {Array} groups: Lista de Grupos CRM
     * @param {Array} ids: Ids ods Grupos CRM da tarifa
     */
    verifyCrmGroups(groups, ids) {
      function checkGroup(group) {
        if (ids.includes(group.codigo)) return true

        if (group.filhos && group.filhos.length > 0)
          return group.filhos.some(checkGroup)

        return false
      }

      return groups.some(checkGroup)
    },

    openPoliciesHandler() {
      this.getHotelData()
      this.loadPaymentForms()
      this.loadRateIncludedItens()
      this.loadPoliciesComponent = true
    },

    openRestrictionHandler() {
      this.getHotelData()
      this.getHotelRoomsData()
      this.loadRestrictionComponent = true
    },

    openPricing() {
      this.accomodationIsOpen = true
      this.additionalPaxIsOpen = true
    },

    loadRateIncludedItens() {
      if (!this.rateIncludedItens.length) {
        this.$rate.getItemsIncludedRate().then((response) => {
          this.rateIncludedItens = response.data.map((item) => {
            return {
              text: item.descricao,
              value: item.codigo
            }
          })
        })
      }
    },

    async loadPaymentForms() {
      if (!this.hotelPaymentForms.length) {
        await this.$paymentMethods
          .listPaymentMethods(this.$route.params.id)
          .then((response) => {
            this.hotelPaymentForms = response.data
          })
      }
    },

    /** Desabilitar regras */
    disableRates() {
      this.isLoading = true

      this.$rate
        .disableRuleRates({ flutuacoes: [this.rateId] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Regra tarifária desativada com sucesso.'
          })

          /** Redirecionar para a tela de listagem de regra tarifarias */
          setTimeout(() => {
            this.$router.push({
              path: `/hoteis/regras-tarifarias/${this.$route.params.id}`
            })
          }, 500)
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar regra tarifária.'
          })
        })
    },

    /** Retornar para a listagem de tarifas */
    goBackRatesList() {
      setTimeout(() => {
        this.$router.push({
          path: `/hoteis/regras-tarifarias/${this.$route.params.id}`
        })
      }, 500)
    },

    /** Carrega cupons ativos ao marcar o checkbox
     * @param {Boolean} value - Estado do checkbox
     */
    handleCouponCheckbox(value) {
      this.associateCoupon = value
      if (!value) this.selectedCoupons = []
    },

    /** Carrega descontos exclusivos ativos ao marcar o checkbox
     * @param {Boolean} value - Estado do checkbox
     */
    handleExclusiveDiscountCheckbox(value) {
      this.associateExclusiveDiscount = value
      if (!value) this.selectedExclusiveDiscounts = []
    },

    /** Pré-carrega as opções de cupons e descontos ao abrir o accordion */
    loadAssociationOptions() {
      if (this.$route.params.rateId) return

      if (!this.couponOptionsLoaded) {
        if (this.getPermissions.includes('lb.cup-des')) {
          this.$coupon.filter({ ativo: 'true' }).then((response) => {
            this.couponOptions = (
              response.data.cuponsDesconto || []
            ).map((item) => ({ ...item, descricao: item.cupom }))
            this.couponOptionsLoaded = true
          })
        } else {
          this.couponOptionsLoaded = true
        }
      }

      if (!this.exclusiveDiscountOptionsLoaded) {
        if (this.getPermissions.includes('cfg.dsc.exc')) {
          this.$exclusiveDiscounts.getDiscountList('true').then((response) => {
            const hotelId = +this.$route.params.id
            this.exclusiveDiscountOptions = (response.data || [])
              .filter((item) => item.hoteis?.includes(hotelId))
              .map((item) => ({ ...item, descricao: item.desconto }))
            this.exclusiveDiscountOptionsLoaded = true
          })
        } else {
          this.exclusiveDiscountOptionsLoaded = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
  pointer-events: none;
}
.hotel {
  &--sidebar {
    ::v-deep {
      .content {
        position: relative;
      }
    }
  }
}
.sidebar {
  &--history {
    background-color: pmw-colors(blue-80);
    text-align: center;
    color: $pmw-white;
    font-size: font-size('size-medium');
    padding: 6px;
    cursor: pointer;
  }

  &--button {
    margin-bottom: 10px;

    &-text {
      margin: auto auto auto 28px;
    }
  }

  &--name {
    text-align: center;
  }

  &--text {
    line-height: 21px;
  }
}

.button {
  &__outline ::v-deep {
    .pmw-button--icon__left {
      gap: 10px;
    }
  }
}

.pmw-info-tooltip {
  ::v-deep {
    .pmw-custom-tooltip {
      display: flex;
      gap: 5px;
      color: $pmw-gray-dark;
      font-size: font-size('size-small');
      line-height: 18px;
    }
    .pmw-box-file {
      padding: 30px 17px 23px 17px;
    }
  }

  .pmw-custom-tooltip--arrow {
    display: none;
  }

  &__fill {
    opacity: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }
}

.pmw-accordion {
  box-shadow: 0px 10px 25px rgb(0 0 0 / 10%);
  padding: 0px 24px 0px 24px;
  margin-bottom: 54px;

  &--item {
    padding: 15px 0px;

    ::v-deep {
      .pmw-title-line--title {
        margin-top: 4px;
        font-size: font-size('size-large');
        font-weight: font-weight('weight-medium');
      }

      .pmw-title-line--description {
        margin-bottom: 0px;
      }

      .pmw-title-line {
        margin-bottom: 0px;

        &--line .separate-line {
          display: none;
        }
      }
      .pmw-accordion--content {
        padding: 0 0 20px 0;
      }
    }

    &--item__blocked-tour ::v-deep {
      .pmw-accordion--trigger {
        pointer-events: none;
      }
    }

    &--item__min-spacing ::v-deep {
      .pmw-accordion--content {
        padding: 32px 0px 20px 0px;
      }
    }
  }
}

::v-deep {
  .info-panel {
    text-align: left;
    align-items: center;
    justify-content: normal;
    padding: 14px 30px;
  }

  .pmw-input--field {
    padding: 8px 8px 11px 4px;
  }

  .pmw-select--button {
    padding: 8px 8px 11px 4px;
  }
}

.form {
  &--actions {
    display: flex;
    justify-content: space-between;
  }
}

.associate-discount {
  margin-bottom: 30px;

  &--columns {
    display: flex;
    gap: 40px;
    margin-top: 20px;
  }

  &--column {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 320px;

    ::v-deep .pmw-input-checkbox {
      width: auto;

      &--label {
        width: auto;
        overflow: visible;
        text-overflow: unset;
      }

      input:checked ~ .pmw-input-checkbox--fakebox {
        background-color: pmw-colors('blue-100');
        border-color: pmw-colors('blue-100');
      }
    }
  }

  &--select-item {
    ::v-deep .select-options {
      width: 100%;
    }

    ::v-deep .select-option {
      width: 100%;
    }
  }
}
</style>
